@if (se_abrio_como_dialogo == true) {
  <div mat-dialog-title >
    <h1 class="titulo-simpli">Mis Credenciales</h1>
    <small class="subtitulo-simpli"><input class="no-input nombre-empresa" value="{{business_name}}"></small>
  </div>
}



@if (se_abrio_como_dialogo == true) {
  <div mat-dialog-content class="animate__animated animate__fadeIn">
    <mat-card style="box-shadow: none;">
      <mat-card-content style="overflow: hidden;">
        <div class="item-credenciales animate__animated animate__fadeInRight animate__faster"  (click)="change_sii()">
          <div class="flecha-icon"><span class="material-symbols-outlined">chevron_right</span></div>
          <div> <img src="../../assets/simpli/clave-sii.svg" height="45px" alt="Certificado SII" /></div>
          <div class="cert-item-texto">
            Clave tributaria
            @if (clave_estado.texto) {
              <small class="cert-linea" [ngClass]="clave_estado.clase">
                <span class="material-symbols-outlined">{{ clave_estado.icono }}</span>{{ clave_estado.texto }}
              </small>
            }
          </div>
        </div>
        <div class="item-credenciales animate__animated animate__fadeInRight animate__faster" (click)="change_facturador()">
          <div class="flecha-icon"><span class="material-symbols-outlined">chevron_right</span></div>
          <div> <img src="../../assets/simpli/facturador.svg" height="45px" alt="Certificado SII" /></div>
          <div>Facturador electrónico</div>
        </div>
        <!-- Siempre visible, con cualquier facturador: el certificado también sirve para ceder subiendo el AEC. -->
        <div [ngClass]="{'item-credenciales animate__animated animate__fadeInRight animate__faster':true, 'box-dis':!puede_editar_certificado}"  (click)="change_certificado()">
          <div class="flecha-icon"><span class="material-symbols-outlined">chevron_right</span></div>
          <div> <img src="../../assets/simpli/certificado-sii.svg" height="45px" alt="Certificado SII" /></div>
          <div class="cert-item-texto">
            Certificado digital
            @if (certificado && cert_linea.texto) {
              <small class="cert-linea" [ngClass]="cert_linea.clase">
                <span class="material-symbols-outlined">{{ cert_linea.icono }}</span>{{ cert_linea.texto }}
              </small>
            }
          </div>
        </div>
        @if (certificado) {
          <div class="cert-bajo-item">
            <ng-container *ngTemplateOutlet="certDetalle"></ng-container>
          </div>
        }
        <div class="leyenda">
          Sus datos de clave tributaria están protegidos con altos estándares de encriptación y seguridad, garantizando su privacidad en todo momento.
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}


@if (se_abrio_como_dialogo == false) {
  <form [formGroup]="valForm">
    <div class="row">
      <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <mat-form-field appearance="fill" color="primary" style="position: relative;">
          <mat-label>Clave SII</mat-label>
          <input matInput formControlName="clave_sii" type="password" readonly  (click)="change_sii()">
          <!-- Estado guardado de la clave (obtener-credenciales-sii), sin ir al SII. Un @if por nodo: así se proyecta en su slot. -->
          @if (clave_estado.estado == 'ok') {
            <mat-icon matSuffix class="material-icons icon-sii" [matTooltip]="clave_estado.texto">check_circle</mat-icon>
          }
          @if (clave_estado.estado == 'con_problema') {
            <mat-icon matSuffix class="cert-sufijo" [ngClass]="clave_estado.clase" [matTooltip]="clave_estado.texto" style="cursor: pointer;">{{ clave_estado.icono }}</mat-icon>
          }
          @if (clave_estado.estado == 'cargando') {
            <mat-spinner color="primary" style="margin-right: 10px;" diameter="20" matSuffix></mat-spinner>
          }
          @if (clave_estado.estado == 'sin_clave') {
            <mat-hint>Cargar clave SII</mat-hint>
          }
          @if (clave_estado.estado == 'con_problema') {
            <mat-hint><span class="cert-linea" [ngClass]="clave_estado.clase">{{ clave_estado.texto }}</span></mat-hint>
          }
        </mat-form-field>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12" style="text-align: center;">
        <button class="primary-button"  mat-flat-button style="margin-top: 20px;" (click)="change_sii()">Editar</button>
      </div>
    </div>
    <!-- Certificado digital: siempre visible, con cualquier facturador (también sirve para ceder subiendo el AEC). -->
    <div class="row" style="margin-top: 15px;">
      <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <mat-form-field appearance="fill" color="primary">
          <mat-label>Certificado Digital</mat-label>
          <input matInput formControlName="certificado_sii" placeholder="Sin certificado cargado" style="position: relative;" readonly
            [style.cursor]="puede_editar_certificado ? 'pointer' : 'default'" (click)="change_certificado()">
          <!-- Estado calculado por el backend (sin ir al SII). Un @if por nodo: así se proyecta en su slot. -->
          @if (certificado) {
            <mat-icon matSuffix class="cert-sufijo" [ngClass]="cert_linea.clase" [matTooltip]="cert_linea.texto">{{ cert_linea.icono }}</mat-icon>
          }
          @if (certificado) {
            <mat-hint>
              <span class="cert-hint">
                @if (cert_vence) {
                  <span>Vence el {{ cert_vence }}</span>
                  <span class="cert-sep">·</span>
                }
                <span class="cert-linea" [ngClass]="cert_linea.clase">{{ cert_linea.texto }}</span>
              </span>
            </mat-hint>
          }
          @if (!certificado && success_certificado == true) {
            <mat-icon matSuffix class="icon-sii">check_circle</mat-icon>
          }
          @if (!certificado && requiere_completar == true) {
            <mat-icon  matTooltip="Requiere completar información" matSuffix style="color:gray;">error_outline</mat-icon>
          }
          @if (!certificado && fecha_vencimiento == null) {
            <mat-hint>Carga tu Certificado Digital</mat-hint>
          }
          @if (!certificado && fecha_vencimiento != null) {
            <mat-hint>Fecha de Vencimiento: {{ fecha_vencimiento | date:'dd/MM/yy' }}</mat-hint>
          }
        </mat-form-field>
        @if (certificado) {
          <div class="cert-bajo-campo">
            <ng-container *ngTemplateOutlet="certDetalle"></ng-container>
          </div>
        }
      </div>
      <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12" style="text-align: center;">
        <button class="primary-button" mat-flat-button style="margin-top: 20px;" [disabled]="!puede_editar_certificado" (click)="change_certificado()">Editar</button>
      </div>
    </div>
    <div class="row" style="margin-top: 15px;">
      <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <mat-form-field appearance="fill" color="primary">
          <mat-label>Facturador Electrónico</mat-label>
          <input matInput formControlName="facturador" style="position: relative;" readonly (click)="change_facturador()">
          @if (success_facturador == true) {
            <mat-icon matSuffix class="icon-sii">check_circle</mat-icon>
          }
          <mat-hint>Indicanos tu Facturador Electrónico</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12" style="text-align: center;">
        <button class="primary-button" mat-flat-button style="margin-top: 20px;" (click)="change_facturador()">Editar</button>
      </div>
    </div>
    @if (es_mi_pyme == false) {
      <div class="row animate__animated animate__fadeIn">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div style="margin-top: 30px;padding: 5px;">
            <small style="font-size: 14px;">
              Tu sistema de facturación aún no se enlaza con nosotros, por ahora no podrás usar el 100% de las funciones de nuestra plataforma.
              Revisa lo que si podrás realizar en nuestra plataforma  <strong style="text-decoration: underline;cursor:pointer;" [mdePopoverTriggerFor]="appPopover" mdePopoverTriggerOn="hover" #popoverTrigger="mdePopoverTrigger"> aqui!</strong>
              <mde-popover #appPopover="mdePopover" [mdePopoverOverlapTrigger]="false" [mdePopoverCloseOnClick]="false">
                <mat-card style="padding:25px">
                  <ol style="padding-left: 0;font-size: 14px;">
                    <li>Consultar facturas vigentes</li>
                    <li>Revisar el estado de tu cartera</li>
                    <li>Realizar simulaciones</li>
                    <li>Ver tus excedentes</li>
                  </ol>
                </mat-card>
              </mde-popover>
            </small>
          </div>
        </div>
      </div>
    }
  </form>
}







@if (se_abrio_como_dialogo == true) {
  <div mat-dialog-actions>
    <button class="secondary-button"  mat-flat-button mat-dialog-close>
      Cerrar
    </button>
    <button class="primary-button"  mat-flat-button mat-dialog-close>
      Finalizar
    </button>
  </div>
}






<!-- Debajo del certificado, en las dos vistas: «Validar en el SII» y, si hay, qué pasa y qué hacer. -->
<ng-template #certDetalle>
  @if (mostrar_validar) {
    <button type="button" class="cert-link" [disabled]="validando" (click)="validar_certificado($event)">
      <span class="material-symbols-outlined" [class.mat-spin]="validando">{{ validando ? 'progress_activity' : 'refresh' }}</span>
      <span class="cert-link-texto">{{ validando ? 'Validando en el SII…' : 'Validar en el SII' }}</span>
    </button>
  }
  @if (cert_detalle) {
    <div class="error-msg cert-aviso">
      <span class="material-symbols-outlined">error</span>
      <div>
        {{ cert_detalle }}
        @if (cert_permisos) {
          <p class="cert-permisos">
            <span>Permisos de tu RUT en el SII:</span>
            <span [ngClass]="cert_permisos.firmar ? 'estado-ok' : 'estado-error'">
              <span class="material-symbols-outlined">{{ cert_permisos.firmar ? 'check_circle' : 'cancel' }}</span>Firmar documentos
            </span>
            <span [ngClass]="cert_permisos.enviar ? 'estado-ok' : 'estado-error'">
              <span class="material-symbols-outlined">{{ cert_permisos.enviar ? 'check_circle' : 'cancel' }}</span>Enviar documentos
            </span>
          </p>
        }
      </div>
    </div>
  }
  @if (cert_aviso) {
    <div class="warning-msg cert-aviso">
      <span class="material-symbols-outlined">schedule</span>
      <div>{{ cert_aviso }}</div>
    </div>
  }
  @if (aviso_validacion) {
    <div class="info-msg cert-aviso">
      <span class="material-symbols-outlined">info</span>
      <div>{{ aviso_validacion }}</div>
    </div>
  }
</ng-template>
